import React from "react";
import Btn from "../CommonElements/Button";
import { Col, Row } from "reactstrap";
import { hasPermission } from "../Utils/userUtils";

export default function TableButtons({
  handleDelete,
  handleEdit,
  row,
  handleView,
  showEditButton = true,
  showDeleteButton = true,
  entity,
}) {
  const style2 = { width: 70, fontSize: 13, padding: 5, margin: 3 };
  return (
    <div style={{ display: "flex" }}>
      {handleView ? (
        <span>
          <Btn
            attrBtn={{
              onClick: () => {
                handleView(row);
              },
              style: style2,
              color: "secondary btn-xs",
              type: "button",
            }}
          >
            Ver
          </Btn>
        </span>
      ) : (
        ""
      )}
      {showEditButton && hasPermission(`edit_${entity}`) ? (
        <span>
          <Btn
            attrBtn={{
              style: style2,
              color: "primary btn-xs",
              type: "button",
              onClick: () => {
                handleEdit(row);
              },
            }}
          >
            Modificar
          </Btn>
        </span>
      ) : (
        ""
      )}
      {showDeleteButton && hasPermission(`delete_${entity}`) ? (
        <span>
          <Btn
            attrBtn={{
              style: style2,
              className: "me-2",
              color: "danger btn-xs",
              type: "button",
              onClick: () => {
                handleDelete(row);
              },
            }}
          >
            Eliminar
          </Btn>
        </span>
      ) : (
        ""
      )}
    </div>
  );
}
